import React from 'react'
import { Grid } from '@react-three/drei'
import { OrbitControls, Environment } from '@react-three/drei'
import { useSelector } from 'react-redux'
import {E_MainLato} from "../components/Utils/enumerations"

import Pedana from './Pedana/Pedana'
import Rampa from "../components/Rampa/Rampa"
import Paraventi from './Paraventi/Paraventi'
import Ombrelloni from "./Ombrelloni/Ombrelloni"
import BaseDirections from './Base/BaseDirections'
import Cristal from "../components/Cristal/Cristal"
import BasePiattaforma from './Base/BasePiattaforma'
import Cameras from './Cameras'
import Lights from './Lights'

// Scena 3D principale che viene visualizzata
export default function Experience() {  
  const canDrawElements = useSelector(state => state.uiMainMenu.canDrawElements);
  const isPedanaVisible = useSelector(state => state.uiPedanaMenu.isVisible);
  const isPedanaSelected = useSelector(state => state.uiPedanaMenu.isVisible);
  const B_rampaDisabili = useSelector(state => state.uiPedanaMenu.rampaDisabili);
  const latoIngresso = useSelector(state => state.uiMainMenu.ingresso);
  const isParaventiVisible = useSelector(state => state.uiParaventiMenu.isVisible);
  const isOmbrelloniVisible = useSelector(state => state.uiOmbrelloniMenu.isVisible);
  const isCristalVisible = useSelector(state => state.uiCristalMenu.isVisible);
  const darkTheme = useSelector(state => state.uiMenuState.darkTheme);

  // Genera la grisglia del pavimento
  function GroundPlane() {
    return (
      <group>
        <Grid infiniteGrid={true} cellSize={0.5} cellThickness={1} cellColor="#e1e1e1" sectionSize={5} sectionThickness={1.5} sectionColor={darkTheme ? "#d30000" : "#9d4b4b"} fadeDistance={35} fadeStrength={1.5}/>
      </group>
    );
  }

  return (
    <>    
        <Environment files={`${process.env.PUBLIC_URL}/img/modern_buildings_2.hdr`} />     
        <OrbitControls makeDefault enableDamping={false} maxPolarAngle={Math.PI / 2 - 0.1}/>
        <Cameras />    
        <Lights />
        {GroundPlane()}
        <BaseDirections />
        {canDrawElements && <group>
          {isPedanaVisible ? <Pedana /> : <BasePiattaforma />}
          {B_rampaDisabili && latoIngresso !== E_MainLato.Scegli.toString() && isPedanaSelected && <Rampa />}
          {isParaventiVisible && <Paraventi />}   
          {isOmbrelloniVisible && <Ombrelloni /> }
          {isCristalVisible && <Cristal />}        
        </group>}        
    </>
  )
}